/**
 * Created by sagardesai on 11/07/18.
 */
import {RSAA} from 'redux-api-middleware';
import {API_ENDPOINT, AUTH_HEADERS, X_AUTHORIZATION} from "../../util/constants";
import * as types from "../types";
import {handleUnauthorizedAccess} from "../../util/utility";

export function blockViewer(token, api_token,user_id,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/block/user/${user_id}?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(data),
            types: [types.BLOCK_UNBLOCK_VIEWER_REQUEST, types.BLOCK_UNBLOCK_VIEWER_RECEIVE, {
                type: types.BLOCK_UNBLOCK_VIEWER_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}


export function unBlockViewer(token, api_token, user_id) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/unblock/user/${user_id}?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.BLOCK_UNBLOCK_VIEWER_REQUEST, types.BLOCK_UNBLOCK_VIEWER_RECEIVE, {
                type: types.BLOCK_UNBLOCK_VIEWER_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetBlockUnBlockData = () => ({
    type: types.RESET_BLOCK_UNBLOCK_VIEWER,
    payload: null
});